/**
 * Enumeration for event levels of an Object Event (Notification).
 *
 * @readonly
 * @enum {string}
 */
export const EventLevels = Object.freeze({
    MESSAGE: 'MESSAGE',
    NOTICE: 'NOTICE',
    WARNING: 'WARNING',
    ALARM1: 'ALARM1',
    ALARM2: 'ALARM2',
    ALARM3: 'ALARM3'
})
